import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { getWarehouseTutorialType } from "../joyrideStepHelpers";
import { WarehouseTutorialType } from "../../../../utils/enums";

const WarehouseSelectionStep: React.FC = () => {
    const { t } = useTranslation();
    const tutorialType = getWarehouseTutorialType();

    let content: React.ReactNode;

    switch (tutorialType) {
        case WarehouseTutorialType.WAREHOUSE_PRODUCT_MOVEMENT:
            content = (
                <p className="fs-7 mb-0">
                    <span className="fw-bold me-1">
                        {t("Select the warehouse you want to work with and go to" + " the warehouse products")}
                    </span>
                    (<i className="bi bi-basket"></i>)
                </p>
            );
            break;
        case WarehouseTutorialType.PRODUCT_SALES:
            content = (
                <p className="fs-7 mb-0">
                    <Trans
                        i18nKey="tutorial.warehouseSelectionStepSales"
                        components={{
                            strong: <strong />,
                        }}
                    />
                </p>
            );
            break;

        default:
            content = <></>;
    }

    return content;
};

export default WarehouseSelectionStep;
